import s from './style.module.scss';
import { DoubleRightOutlined } from '@ant-design/icons';
const CardButton = (props) => {
    const { setShowCaseCard, expand } = props;

    const toggleExpand = () => {
        setShowCaseCard(!expand);
    };
    return (
        <div data-expand={expand} onClick={toggleExpand} className={s['card-button']}>
            <span className={s['card-button-text']}>案例库</span>
            <span className={s['card-button-icon']}>
                <DoubleRightOutlined />
            </span>
        </div>
    );
};
export default CardButton;
